import { PieChart, Pie, Cell, Tooltip, Surface, Symbols, Legend } from "recharts";
import { ChartContainer } from "./charts";

interface PropsType {
  isRing?: boolean;
  hasNumber?: boolean;
  text: string;
  data: any;
}


const CustomPieChart = ({ isRing, hasNumber, text, data }: PropsType) => {
  const inner = isRing ? 60 : 100;
  const outer = isRing ? 75 : 120;
  const hw = isRing ? 160 : 300;
  const c = isRing ? 75 : 85;
  const xy = isRing ? 80 : 88;
  
  // Still show a default pie chart if no category has a value greater than 0
  let textCategory;
  const totalCategoriesLargerThan0 = data.filter((category) => category.value !== 0);

  if (hasNumber) {
    textCategory = data.find((item) => item.name.toLowerCase() === text.toLowerCase());
  }

  if (totalCategoriesLargerThan0.length === 0) {
    // If no category is found we should just display the text
    if (textCategory) {

      // Set the default data
      data = [
        {
          name: "No Data",
          value: 100,
          color: textCategory.color,
        }
      ];
    }
  }
  
  // [{"color":"#7500C0","name":"Open","value":0},{"color":"#DA9EFF","name":"In Progress","value":3},{"color":"#7b7881","name":"Closed","value":0},{"color":"#FF7800","name":"Request Tuning","value":0}]

  return (
    <ChartContainer>
      { 
        data && data.length > 0 ? 
        <PieChart width={hw} height={hw}>
          <Pie
            data={data}
            cx={c}
            cy={c}
            innerRadius={inner}
            outerRadius={outer}
            stroke=""
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={totalCategoriesLargerThan0.length > 0 ? entry.color : `#460073`} />
            ))}
          </Pie>
          { 
            // If we want to display the sum and name of a category
            hasNumber ? <>
              <text
                x={xy}
                y={xy - 15}
                fill="white"
                textAnchor="middle"
                fontSize="1.4em"
                fontWeight={300}
                dominantBaseline="central"
              >
                <tspan alignmentBaseline="middle">
                  {textCategory.value}
                </tspan>
              </text>
              <text
                x={xy}
                y={xy + 10}
                fill="white"
                textAnchor="middle"
                fontSize="1em"
                fontWeight={300}
                dominantBaseline="central"
              >
                <tspan>
                  {textCategory.name}
                </tspan>
              </text>      
            </> :
            // If we want to display the given text value
            <text
              x={xy}
              y={xy}
              fill="white"
              textAnchor="middle"
              fontSize="1em"
              fontWeight={300}
              dominantBaseline="central"
            >
              <tspan>
                {text}
              </tspan>
            </text>   
          }
        
        </PieChart> :
        <></>
      }
    </ChartContainer>
  );
};

export default CustomPieChart;


